import { ADDRESSES_ACTIONS } from './addresses.types'

/**
 * @param {Array} payload
 * @returns {Object}
 */
export const setAddressesAction = payload => ({
  type: ADDRESSES_ACTIONS.SET_ADDRESSES,
  payload
})

/**
 * @param {Object} payload
 * @returns {Object}
 */
export const updateAddressAction = payload => ({
  type: ADDRESSES_ACTIONS.UPDATE_ADDRESS,
  payload
})

/**
 * @param {import('../slice.types').SliceStatus} payload
 * @returns {Object}
 */
export const setAddressesStatusAction = payload => ({
  type: ADDRESSES_ACTIONS.SET_STATUS,
  payload
})

/**
 * @param {import('../slice.types').SliceError} payload
 * @returns {Object}
 */
export const setAddressesErrorsAction = payload => ({
  type: ADDRESSES_ACTIONS.SET_ERRORS,
  payload
})

/**
 * @returns {Object}
 */
export const clearAddressesErrorsAction = () => ({
  type: ADDRESSES_ACTIONS.CLEAR_ERRORS
})
